import React, { useEffect, useState } from 'react';
import places from 'places.js';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import { useTranslation } from 'react-i18next';
import config from '../../config';

const LocationInput = ({ initialValue, onValueChanged }) => {
  const { t } = useTranslation(['search']);

  const [location, setLocation] = useState({
    lat: initialValue.lat,
    long: initialValue.long
  });
  const [inputValue, setInputValue] = useState(initialValue.displayText);

  const handlePosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(updateUserPosition);
    }
  };

  const handleFocus = (event) => {
    event.nativeEvent.target.select();
  };

  const updateUserPosition = ({ coords }) => {
    setInputValue(t('search:current-position'));
    handleLocation(coords.latitude, coords.longitude, t('search:current-position'));
  };

  const handleLocation = (lat, long, displayText) => {
    setLocation({
      lat,
      long
    });

    if (typeof onValueChanged === 'function') {
      onValueChanged({
        lat,
        long,
        displayText: displayText
      });
    }
  };

  useEffect(() => {
    const placesAutocomplete = places({
      appId: config.algolia.appId,
      apiKey: config.algolia.apiKey,
      container: document.querySelector('#location-input')
    })
      .configure({
        language: 'fr',
        countries: ['fr'],
        type: ['address', 'city']
      });

    placesAutocomplete.on('change', (e) => {
      setInputValue(e.suggestion.value);
      handleLocation(e.suggestion.latlng.lat, e.suggestion.latlng.lng, e.suggestion.value);
    });

    placesAutocomplete.on('clear', () => {
      setInputValue('');
      handleLocation(null, null, '');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="location-input">
      <Paper className="input-wrapper">
        <IconButton onClick={handlePosition}>
          <MyLocationIcon />
        </IconButton>
        <InputBase
          id="location-input"
          className="input-control"
          value={inputValue}
          onFocus={handleFocus}
          onChange={e => setInputValue(e.target.value)}
        />
      </Paper>
    </div>
  );
};

export default LocationInput;
